import { FiArrowLeft } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import styles from './NotFoundPage.module.css';

const NotFoundPage = () => {
    const { t } = useTranslation();
    return (
    <section className={styles.notFound}>
        <span>404</span>
        <p>{t('notFound.eyebrow')}</p>
        <h1>{t('notFound.title')}</h1>
        <p>{t('notFound.description')}</p>
        <Link to="/"><FiArrowLeft /> {t('notFound.back')}</Link>
    </section>
    );
};

export default NotFoundPage;
